import { PublicKey } from "@solana/web3.js" // eslint-disable-line @typescript-eslint/no-unused-vars
import BN from "bn.js" // eslint-disable-line @typescript-eslint/no-unused-vars
import * as types from "../types" // eslint-disable-line @typescript-eslint/no-unused-vars
import * as borsh from "@coral-xyz/borsh"

export interface UninitializedJSON {
  kind: "Uninitialized"
}

export class Uninitialized {
  static readonly discriminator = 0
  static readonly kind = "Uninitialized"
  readonly discriminator = 0
  readonly kind = "Uninitialized"

  toJSON(): UninitializedJSON {
    return {
      kind: "Uninitialized",
    }
  }

  toEncodable() {
    return {
      Uninitialized: {},
    }
  }
}

export interface LeafSchemaEventJSON {
  kind: "LeafSchemaEvent"
}

export class LeafSchemaEvent {
  static readonly discriminator = 1
  static readonly kind = "LeafSchemaEvent"
  readonly discriminator = 1
  readonly kind = "LeafSchemaEvent"

  toJSON(): LeafSchemaEventJSON {
    return {
      kind: "LeafSchemaEvent",
    }
  }

  toEncodable() {
    return {
      LeafSchemaEvent: {},
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fromDecoded(obj: any): types.BubblegumEventTypeKind {
  if (typeof obj !== "object") {
    throw new Error("Invalid enum object")
  }

  if ("Uninitialized" in obj) {
    return new Uninitialized()
  }
  if ("LeafSchemaEvent" in obj) {
    return new LeafSchemaEvent()
  }

  throw new Error("Invalid enum object")
}

export function fromJSON(
  obj: types.BubblegumEventTypeJSON
): types.BubblegumEventTypeKind {
  switch (obj.kind) {
    case "Uninitialized": {
      return new Uninitialized()
    }
    case "LeafSchemaEvent": {
      return new LeafSchemaEvent()
    }
  }
}

export function layout(property?: string) {
  const ret = borsh.rustEnum([
    borsh.struct([], "Uninitialized"),
    borsh.struct([], "LeafSchemaEvent"),
  ])
  if (property !== undefined) {
    return ret.replicate(property)
  }
  return ret
}
